import Typography from '@zeptonow/zui/Typography';
import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { filterRoutes, findNode } from './utils';
import getModuleRoutes from '../../routes/ModuleRoutes';
import { generateImage } from '../../utilities/utils';
import { MenuTypes } from '@zeptonow/zui/Menu';
import { AppStore } from '../../store';

const BreadcrumbItems = () => {
  const { pathname } = useLocation();

  const isFormDirty = AppStore((state) => state.isFormDirty);
  const setShowUnsavedWorkConfirmationModal = AppStore(
    (state) => state.setShowUnsavedWorkConfirmationModal
  );

  const onLinkItemClick = (event: React.MouseEvent<HTMLElement>) => {
    if (isFormDirty) {
      event.preventDefault();
      setShowUnsavedWorkConfirmationModal(true);
    }
  };

  const moduleRoutes = useMemo(() => {
    return getModuleRoutes(pathname);
  }, [pathname]);

  const filteredRoutes =
    filterRoutes({
      routes: moduleRoutes,
    }) ?? [];

  const pathnames = pathname.split('/').filter((x) => x);

  let currentRoute = '';

  const extraBreadcrumbItems = pathnames.map((path, key) => {
    const last = key === pathnames.length - 1;
    currentRoute += `/${path}`;
    const item = findNode('route', currentRoute, filteredRoutes as MenuTypes[]);
    if (!item) return null;

    return last || !item.component ? (
      <Typography
        key={`${key}-${item?.title}`}
        className={
          last ? `px-2 py-1 rounded-md bg-primary-25 text-primary-700` : ''
        }
      >
        {item?.title}
      </Typography>
    ) : (
      <div onClickCapture={onLinkItemClick}>
        <Link
          key={`${key}-${item?.title}`}
          color="inherit"
          to={currentRoute}
          className={`${
            item && typeof item.component !== 'undefined'
              ? 'cursor-pointer'
              : 'cursor-default'
          }`}
        >
          {item?.title}
        </Link>
      </div>
    );
  });
  const filteredBreadCrumbItems = extraBreadcrumbItems.filter(Boolean);
  const breadcrumbItems: any[] = [
    <div onClickCapture={onLinkItemClick}>
      <Link key="home" color="inherit" to="/">
        {generateImage({
          name: 'home',
          alt: 'home icon',
          className: 'h-4 w-4',
        })}
      </Link>
    </div>,
    ...filteredBreadCrumbItems,
  ];

  return breadcrumbItems;
};

export default BreadcrumbItems;
